import {Component, Input} from '@angular/core';
import {FillBlanksAnswer} from "@modules/activity-edition/core/features/activity-editor-panel/answerTypes";
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Component({
  selector: 'app-activity-edition-preview-fill-blanks',
  templateUrl: './activity-edition-preview-fill-blanks.component.html',
  styleUrl: './activity-edition-preview-fill-blanks.component.scss'
})
export class ActivityEditionPreviewFillBlanksComponent {
    @Input() answersState!: FillBlanksAnswer;

    constructor(private sanitizer: DomSanitizer) {}

    public getSentence(): SafeHtml {
        let answerIndex = 0;
        const sentenceWithBlanks = this.answersState.sentence.replace(/\[\]/g, () => {
            const answer = this.answersState.answers[answerIndex] || [];
            const charCount = answer[0]?.length || 0;
            answerIndex++;
            return `<span style="width:${charCount}ch;" class="activity-edition-preview-fill-blanks__blank"></span>`;
        });
        return this.sanitizer.bypassSecurityTrustHtml(sentenceWithBlanks);
    }

    /*
    * {
    * "isFillBlanksAnswerActive": true,
    * "answers": [ [ "chaussettes" ], [ "Duchesse" ] ],
    * "isCaseSensitive": true,
    * "sentence": "Les [] de l'archi [] sont elles sèches archi sèches ?",
    * "isOtherPossibleAnswersControl": false
    * }
    * */




}